module.exports = __webpack_public_path__ + "static/media/partner-agents-banner.4da4cc25.webp";